import React, { useState, useEffect } from 'react';
import { AddPersonalConsumption, GetPersonalStats } from '../../Backend/ApiCalls';
import './PersonalTrackerComponent.css';

const PersonalTrackerComponent = () => {
    const [counts, setCounts] = useState({
        cubata: 0,
        cerveza: 0,
        cigarro: 0,
        porro: 0,
    });

    useEffect(() => {
        async function fetchStats() {
            try {
                const { data } = await GetPersonalStats();

                const initialCounts = data.reduce((acc, item) => {
                    if (acc[item.tipoBebida]) {
                        acc[item.tipoBebida] += item.total;
                    } else {
                        acc[item.tipoBebida] = item.total;
                    }
                    return acc;
                }, {});

                setCounts((prev) => ({
                    ...prev,
                    ...initialCounts,
                }));
            } catch (error) {
                console.error('Error obteniendo estadísticas:', error);
            }
        }

        fetchStats();
    }, []);

    const handleAdd = async (tipoBebida) => {
        try {
            const { response, data } = await AddPersonalConsumption(tipoBebida);

            if (response.ok) {
                setCounts((prev) => ({
                    ...prev,
                    [tipoBebida]: prev[tipoBebida] + 1,
                }));
            } else {
                console.error('Error al añadir consumo:', data.error);
                alert('Error al añadir consumo');
            }
        } catch (error) {
            console.error('Error al añadir consumo:', error);
            alert('Error al añadir consumo');
        }
    };

    return (
        <div className="personal-tracker">
            <h1 className="tracker-title">Tu Wrapped Personal 2024 🍺🚬</h1>
            <div className="tracker-buttons">
                {['cubata', 'cerveza', 'cigarro', 'porro'].map((tipo) => (
                    <div key={tipo} className="tracker-item">
                        <button
                            className="tracker-button"
                            onClick={() => handleAdd(tipo)}
                        >
                            +1 {tipo.charAt(0).toUpperCase() + tipo.slice(1)}{' '}
                            {tipo === 'porro'
                                ? '🌿'
                                : tipo === 'cigarro'
                                ? '🚬'
                                : tipo === 'cerveza'
                                ? '🍺'
                                : '🍹'}
                        </button>
                        <h2 className="tracker-count">{counts[tipo]}</h2>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PersonalTrackerComponent;
